export default "__VITE_ASSET__B0HLc4cg__"